<script lang="ts">
	import { page } from '$app/stores';
	import { lazyLoad } from '$lib/actions/lazyLoad';
	import compass from '$lib/assets/images/icons/compass-large.svg';
	import __ from '$lib/stores/TranslationStore';
	import Cta from '../Global/Cta.svelte';
</script>

<div class="bg-secondary-bright">
	<div class="container mx-auto max-w-5xl py-16 text-center text-white">
		<div class="mx-auto flex justify-center">
			<img use:lazyLoad={compass} class="h-[80px] w-[54px]" alt="simulação" loading="lazy" />
		</div>
		<h3 class="mt-12 text-4xl font-semibold lg:mt-16 lg:text-6xl">
			{$__('Faça uma simulação e conheça as vantagens')}
		</h3>
		<p class="mt-6 text-lg font-light leading-8 lg:mt-12 lg:text-2xl">
			{@html $__(
				'Fácil, rápido e seguro.<br>Use o simulador e veja as opções de crédito mais vantajosas que conseguimos para si!'
			)}
		</p>
		<div class="text-center">
			<Cta
				type="anchor"
				props={{
					href: '/simuladores'
				}}
				class="mt-10 inline-block bg-primary-light px-10 py-4 font-semibold leading-nav-button text-dark md:border-0 lg:mt-20 lg:px-32 2xl:text-nav-button"
			>
				{$__('Simular crédito')}
			</Cta>
		</div>
	</div>
</div>
